import i18next from 'i18next';
import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
// import tr from './navigation-i18n/tr';

i18next.addResourceBundle('en', 'navigation', en);
// i18next.addResourceBundle('tr', 'navigation', tr);
i18next.addResourceBundle('ar', 'navigation', ar);

const navigationConfig = [
	{
		id: 'dashboards',
		title: 'Dashboard',
		translate: 'DASHBOARDS',
		type: 'item',
		icon: 'dashboard',
		url: '/dashboard'
	},
	{
		id: 'store',
		title: 'Store',
		translate: 'STORES',
		type: 'item',
		icon: 'category',
		url: '/store',
		exact: true
	},
	{
		id: 'store-report',
		title: 'Store Report',
		translate: 'STOREREPORT',
		type: 'item',
		icon: 'report',
		url: '/store-report',
		exact: true
	},
	{
		id: 'upload-invoice',
		title: 'Upload File of Invoices',
		translate: 'UPLOADINVOICE',
		type: 'item',
		icon: 'cloud_upload',
		url: '/upload-invoice',
		exact: true
	},
	{
		id: 'products',
		title: 'Productos',
		translate: 'Productos',
		type: 'item',
		icon: 'fastfood',
		url: '/products',
		exact: true
	},
	// {
	// 	id: 'place',
	// 	title: 'Places',
	// 	translate: 'PLACE',
	// 	type: 'collapse',
	// 	icon: 'restaurant',
	// 	children:[
	// 		{
	// 			id: 'manage-places',
	// 			title: 'All Places',
	// 			translate: 'MANAGEPLACES',
	// 			type: 'item',
	// 			icon: 'restaurant',
	// 			url: '/manage-places',
	// 			exact: true
	// 		},
	// 		{
	// 			id: 'claimRequest',
	// 			title: 'Claimed by Owners',
	// 			translate: 'CLAIMREQUESTS',
	// 			type: 'item',
	// 			icon: 'view_list',
	// 			url: '/claim-requests'
	// 		},
	// 		{
	// 			id: 'customerClaimRequest',
	// 			title: 'Claimed by Customers',
	// 			translate: 'CLAIMREQUESTSCUSTOMER',
	// 			type: 'item',
	// 			icon: 'view_stream',
	// 			url: '/customer-claim-requests'
	// 		},
	// 		{
	// 			id: 'manage-user-places',
	// 			title: 'Added by Customers',
	// 			translate: 'MANAGECUSTOMERSPLACES',
	// 			type: 'item',
	// 			icon: 'storefront',
	// 			url: '/manage-users-places',
	// 			exact: true
	// 		},
	// 		{
	// 			id: 'suggetionEdit',
	// 			title: 'Suggested Edits by Customers',
	// 			translate: 'SUGGETIONEDIT',
	// 			type: 'item',
	// 			icon: 'table_chart',
	// 			url: '/suggetion-edit'
	// 		},
	// 		{
	// 			id: 'reported',
	// 			title: 'Reported by Customers',
	// 			translate: 'REPORTED',
	// 			type: 'item',
	// 			icon: 'report',
	// 			url: '/reported'
	// 		},
	// 	],
	// },
	// {
	// 	id: 'order',
	// 	title: 'Food Orders',
	// 	translate: 'MANAGEORDERS',
	// 	type: 'item',
	// 	icon: 'reorder',
	// 	url: '/manage-order',
	// 	exact: true
	// },
	// {
	// 	id: 'events',
	// 	title: 'Events',
	// 	translate: 'MANAGEEVENTS',
	// 	type: 'item',
	// 	icon: 'event',
	// 	url: '/events',
	// 	exact: true
	// },
	// {
	// 	id: 'manageusers',
	// 	title: 'Customers',
	// 	translate: 'MANAGECUSTOMERS',
	// 	type: 'item',
	// 	icon: 'people',
	// 	url: '/manage-users'
	// },
	// {
	// 	id: 'manageowners',
	// 	title: 'Owners',
	// 	translate: 'MANAGEOWNERS',
	// 	type: 'item',
	// 	icon: 'account_circle',
	// 	url: '/manage-owners'
	// },
	// {
	// 	id: 'manage-categories',
	// 	title: 'Categories',
	// 	translate: 'MANAGECATEGORIES',
	// 	type: 'item',
	// 	icon: 'category',
	// 	url: '/manage-categories',
	// 	exact: true
	// },
	// {
	// 	id: 'manage-features',
	// 	title: 'Features',
	// 	translate: 'MANAGEFEATURES',
	// 	type: 'item',
	// 	icon: 'restaurant_menu',
	// 	url: '/manage-features',
	// 	exact: true
	// },
	// {
	// 	id: 'manage-tastes',
	// 	title: 'Tastes',
	// 	translate: 'MANAGETASTE',
	// 	type: 'item',
	// 	icon: 'restaurant_menu',
	// 	url: '/manage-tastes',
	// 	exact: true
	// },
	
	// {
	// 	id: 'newslatter',
	// 	title: 'Newsletter',
	// 	translate: 'MANAGENEWSLATTER',
	// 	type: 'item',
	// 	icon: 'card_membership',
	// 	url: '/manage-newslatter',
	// 	exact: true
	// },
	// {
	// 	id: 'staticPage',
	// 	title: 'Content Pages',
	// 	translate: 'MANAGESTATICPAGE',
	// 	type: 'item',
	// 	icon: 'snippet_folder',
	// 	url: '/manage-contentpage',
	// 	exact: true
	// },
	// {
	// 	id: 'faqPage',
	// 	title: 'FAQ',
	// 	translate: 'MANAGEFAQPAGE',
	// 	type: 'item',
	// 	icon: 'help_outline',
	// 	url: '/manage-faq',
	// 	exact: true
	// },
	// {
	// 	id: 'language',
	// 	title: 'Language',
	// 	translate: 'MANAGELANGUAGE',
	// 	type: 'item',
	// 	icon: 'language',
	// 	url: '/manage-language',
	// 	exact: true
	// },
	// {
	// 	id: 'term',
	// 	title: 'Terms',
	// 	translate: 'MANAGETERMS',
	// 	type: 'item',
	// 	icon: 'perm_data_setting',
	// 	url: '/manage-term',
	// 	exact: true
	// },
	
	
	// {
	// 	id: 'foodcategory',
	// 	title: 'Food Menu Categories',
	// 	translate: 'Food Menu Categories',
	// 	type: 'item',
	// 	icon: 'view_list',
	// 	url: '/food-menu-categories'

	// }
];

export default navigationConfig;
